import FullScreenLoader from './CalendarLoader'
import ThinLoader from './ThinLoader'

export { FullScreenLoader, ThinLoader }
